export enum FilterTypeEnum {
    None = 0,
    Text = 1,
    Select = 2,
    Number = 3,
    Boolean = 4,
    Date = 5,
    DateRange = 6,
    MultipleSelect = 7
  }